import { useState, useEffect } from "react";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import logo from '../assets/img/logo.svg';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { HashLink } from 'react-router-hash-link';
// REMOVED: import { BrowserRouter as Router } from "react-router-dom";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/github-mark-white.svg";
// AboutMe is not directly rendered by NavBar, so no need to import it here.
// import AboutMe from './AboutMe';
import languages from '../assets/img/languages.svg';
import { Link } from 'react-router-dom'; // Import Link for full-page navigation

export const NavBar = ({ language, onLanguageChange, onToggle, isOpen, onOpenChat }) => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);
    // isNavbarOpen is passed as a prop, no need for internal state
    // const [isNavbarOpen, setIsNavbarOpen] = useState(false);
    const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
    // isChatOpen is passed as a prop, no need for internal state
    // const [isChatOpen, setIsChatOpen] = useState(false);

    const email = 'cjimenezr23@gmail.com';
    const subject = 'Contact with Carlos.';
    const body = '';

    // CV links based on language
    const cvLinks = {
        en: 'https://drive.google.com/file/d/1wsBZZiQg7CSTigIllq-x3FlY9wB2skYI/view?usp=sharing',
        es: 'https://drive.google.com/file/d/15wHbXJQsOCHkysDfaBfr7thba3zhk3MB/view?usp=sharing'
    };

    useEffect(() => {
        const onScroll = () => {
            const currentScrollPos = window.pageYOffset;
            setScrolled(currentScrollPos > prevScrollPos);
            setPrevScrollPos(currentScrollPos);
        };

        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [prevScrollPos]);

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
        // Use the onToggle prop to close the navbar if it's open
        if (isOpen) {
            onToggle();
        }
    };

    // handleToggle is now managed by the onToggle prop from App.js
    // const handleToggle = () => {
    //     setIsNavbarOpen(!isNavbarOpen);
    // };

    const handleViewCV = () => {
        window.open(cvLinks[language], '_blank');
        if (isOpen) { // Close navbar after action
            onToggle();
        }
    };

    return (
        <Navbar
            expand="lg"
            fixed="top"
            expanded={isOpen} // Use the isOpen prop
            className={`navbar ${scrolled ? 'navbar-hidden' : ''} ${isOpen ? 'navbar-mobile-open' : ''}`}
        >
            <Container fluid="xxl" className="px-4">
            
                <Navbar.Brand href="/" className="py-0 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    <img src={logo} alt="Logo" style={{ height: '60px' }} />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={onToggle} className="border-0">
                    <span className="navbar-toggler-icon"></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto align-items-center">
                        {/* Use Link for full page routes, HashLink for internal page sections */}
                        <Nav.Link
                            as={Link} // Use `as={Link}` to make Nav.Link behave as a react-router-dom Link
                            to="/"
                            className={activeLink === 'home' ? 'active navbar-link mx-2' : 'navbar-link mx-2'}
                            onClick={() => onUpdateActiveLink('home')}
                        >
                            {language === 'en' ? 'Home' : 'Inicio'}
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/timeline"
                            className={activeLink === 'timeline' ? 'active navbar-link mx-2' : 'navbar-link mx-2'}
                            onClick={() => onUpdateActiveLink('timeline')}
                        >
                            {language === 'en' ? 'Projects' : 'Proyectos'}
                        </Nav.Link>


                        <Nav.Link
                            as={Link}
                            to="/skills"
                            className={activeLink === 'skills' ? 'active navbar-link mx-2' : 'navbar-link mx-2'}
                            onClick={() => onUpdateActiveLink('skills')}
                        >
                            {language === 'en' ? 'Skills' : 'Habilidades'}
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/chat"
                            className={activeLink === 'chat' ? 'active navbar-link mx-2' : 'navbar-link mx-2'}
                            onClick={() => onUpdateActiveLink('chat')}
                        >
                            {language === 'en' ? 'ChatCJR' : 'ChatCJR'}
                        </Nav.Link>
                    </Nav>

                    <div className="navbar-right d-flex align-items-center gap-3">
                        <div className="social-icon d-flex gap-3">
                            <a href="https://linkedin.com/in/carlosjimenezrodriguez" target="_blank" rel="noopener noreferrer">
                                <img src={navIcon1} alt="LinkedIn" style={{ height: '28px' }} />
                            </a>
                            <a href="https://github.com/Carlosjr5" target="_blank" rel="noopener noreferrer">
                                <img src={navIcon2} alt="GitHub" />
                            </a>

                            {/* CV Button */}
                            <button
                                onClick={handleViewCV}
                                className="cv-button btn btn-outline-light px-3 py-1"
                                style={{
                                    borderRadius: '50px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    border: '2px solid #fff',
                                    transition: 'all 0.3s ease-in-out',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    background: 'transparent',
                                    color: '#fff'
                                }}
                            >
                                <i className="fas fa-file-alt"></i>
                                {language === 'en' ? 'CV' : 'CV'}
                            </button>
                        </div>

                        <span className="navbar-text">
                            {/* HashLink for internal page anchors (if you still have any in your app structure) */}
                            {/* If #connect is a section on the same page where the Navbar is used (e.g., /about), HashLink is fine.
                                If it's a completely different page, you'd use <Link to="/about#connect"> or similar. */}
                            <HashLink to='#connect' className="text-decoration-none" onClick={onToggle}>
                                <button
                                    onClick={() => {
                                        window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                                        if (isOpen) { // Close navbar after action
                                            onToggle();
                                        }
                                    }}
                                    className="email-button btn btn-outline-light py-2 px-3"
                                >
                                    {language === 'en' ? 'Email' : 'Email'}
                                </button>
                            </HashLink>
                        </span>

                        <div className="language-selector ms-2">
                            <Dropdown>
                                <Dropdown.Toggle variant="link" id="language-dropdown" className="dropdown-toggle p-0">
                                    <img
                                        src={languages}
                                        alt="Language Selector"
                                        style={{ width: '42px', height: '42px', objectFit: 'contain' }}
                                    />
                                </Dropdown.Toggle>
                                <Dropdown.Menu style={{ backgroundColor: '#333', border: '1px solid #555' }}>
                                    <Dropdown.Item onClick={() => {
                                        onLanguageChange('en');
                                        if (isOpen) { // Close navbar after action
                                            onToggle();
                                        }
                                    }} style={{ color: 'white' }}>
                                        🇬🇧 English
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => {
                                        onLanguageChange('es');
                                        if (isOpen) { // Close navbar after action
                                            onToggle();
                                        }
                                    }} style={{ color: 'white' }}>
                                        🇪🇸 Español
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};